import React, { useEffect } from 'react';
import Navbar from '../../../Components/HomeComponent/Navbar';
import FooterComponent from '../../../Components/Footer/FooterComponent';
import { FaMicrophone, FaMagic, FaChartBar, FaUserTie, FaArrowRight } from 'react-icons/fa';

const SalesPitchAutomation = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Sales Pitch Automation | ToxBox";
  }, []);

  const features = [
    {
      icon: <FaMagic size={32} color="#f59e0b" />,
      title: "AI Script Generation",
      description: "Generate persuasive, personalized sales scripts in seconds based on prospect data."
    },
    {
      icon: <FaMicrophone size={32} color="#f59e0b" />,
      title: "Real-Time Coaching",
      description: "Live prompts and objection handling tips during calls to help reps close confidentially."
    },
    {
      icon: <FaUserTie size={32} color="#f59e0b" />,
      title: "Tone Analysis",
      description: "Analyze voice capability and sentiment to ensure the perfect delivery every time."
    },
    {
      icon: <FaChartBar size={32} color="#f59e0b" />,
      title: "Performance Insights",
      description: "Track pitch effectiveness and iterate on messaging that drives the highest conversions."
    }
  ];

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      {/* Hero Section */}
      <div style={{
        padding: '160px 20px 100px',
        background: 'linear-gradient(135deg, #fffbeb 0%, #ffffff 100%)',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '800',
            color: '#78350f',
            marginBottom: '24px',
            lineHeight: '1.2'
          }}>
            Perfect <span style={{ color: '#d97706' }}>Sales Pitches</span><br />
            Every Single Time
          </h1>
          <p style={{
            fontSize: '1.25rem',
            color: '#4b5563',
            marginBottom: '40px',
            maxWidth: '700px',
            margin: '0 auto 40px',
            lineHeight: '1.6'
          }}>
            Equip your team with AI-powered scripts, real-time coaching, and automated personalization to win more deals.
          </p>
          <a href="/demo-form" style={{
            padding: '16px 36px',
            background: '#d97706',
            color: 'white',
            borderRadius: '50px',
            fontWeight: '700',
            textDecoration: 'none',
            boxShadow: '0 10px 20px -5px rgba(217, 119, 6, 0.4)'
          }}>
            Automate My Pitch
          </a>
        </div>
      </div>

      {/* Features Grid */}
      <div style={{ padding: '100px 20px', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#1e293b' }}>Master the Art of the Pitch</h2>
            <p style={{ color: '#64748b', fontSize: '1.1rem', marginTop: '10px' }}>Consistent messaging across your entire sales organization.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px' }}>
            {features.map((item, index) => (
              <div key={index} style={{
                padding: '32px',
                borderRadius: '24px',
                background: '#fff7ed',
                border: '1px solid #ffedd5',
                textAlign: 'left'
              }}>
                <div style={{ marginBottom: '20px' }}>{item.icon}</div>
                <h3 style={{ fontSize: '1.4rem', fontWeight: '700', color: '#78350f', marginBottom: '12px' }}>{item.title}</h3>
                <p style={{ color: '#57534e', lineHeight: '1.6' }}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div style={{ padding: '100px 20px', background: '#1e293b', color: 'white' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '60px' }}>From Prep to Close</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '40px' }}>
            <div style={{ border: '1px solid rgba(255,255,255,0.1)', padding: '30px', borderRadius: '16px', background: 'rgba(255,255,255,0.02)' }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '16px', color: '#fcd34d' }}>1. Research</h3>
              <p style={{ color: '#d1d5db' }}>AI scans prospect data (LinkedIn, Company News) to find hooks.</p>
            </div>
            <div style={{ border: '1px solid rgba(255,255,255,0.1)', padding: '30px', borderRadius: '16px', background: 'rgba(255,255,255,0.02)' }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '16px', color: '#fcd34d' }}>2. Craft</h3>
              <p style={{ color: '#d1d5db' }}>Generates a tailored email, script, or presentation outline.</p>
            </div>
            <div style={{ border: '1px solid rgba(255,255,255,0.1)', padding: '30px', borderRadius: '16px', background: 'rgba(255,255,255,0.02)' }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '16px', color: '#fcd34d' }}>3. Optimize</h3>
              <p style={{ color: '#d1d5db' }}>Tracks response rates and refines messaging automatically.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer CTA */}
      <div style={{ padding: '80px 20px', textAlign: 'center', background: '#f8fafc' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '800', color: '#1e293b', marginBottom: '20px' }}>Ready to Boost Your Win Rates?</h2>
        <a href="/contact" style={{
          display: 'inline-flex', alignItems: 'center', gap: '10px',
          color: '#d97706', fontWeight: '700', fontSize: '1.2rem', textDecoration: 'none'
        }}>
          Book a Strategy Session <FaArrowRight />
        </a>
      </div>

      <FooterComponent />
    </div>
  );
};

export default SalesPitchAutomation;
